import { Button, Card, Col, Row, Typography } from "antd"
import { EditButton, DeleteButton } from "../../../shared"
import Moment from "moment"
import { extendMoment } from "moment-range"
const moment = extendMoment(Moment)
moment.locale("es")
import {
  implementer,
  getReadableValue
} from "../../../../helpers/selectOptions"
import PropTypes from "prop-types"
import { Draggable } from "react-beautiful-dnd"
import { CopyOutlined, MenuOutlined, MessageOutlined } from "@ant-design/icons"
import { useContext, useEffect, useState } from "react"
import { CommentButton} from "../../../admin/submissions/review"

import { CommentsContext } from "../../../../contexts/admin/submissions/review/comments/context"
import { BlockComponent } from "../../../../helpers/blockComponent"
import { LockOutlined, UnlockOutlined } from "@ant-design/icons"
import { isArray } from "lodash"


ActivityItem.propTypes = {
  data: PropTypes.object,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  readOnly: PropTypes.bool,
  review: PropTypes.bool,
  index: PropTypes.number,
  objectiveIndex: PropTypes.any,
  activityType: PropTypes.string,
  onDuplicate: PropTypes.func
}

export function ActivityItem({
  data,
  onDelete,
  onEdit,
  readOnly,
  review,
  index,
  objectiveIndex,
  activityType,
  onDuplicate,
  commentID,
  admin,
  implementationPlace,
  rol
}) {
  const {
    description = "N/A",
    responsible = "N/A",
    baseline = "N/A",
    goal = "N/A",
    meansOfVerification = [],
    place = "N/A",
    months = "N/A",
    title = "N/A",
    orderIndex,
    key
  } = data

  let formattedMonths = months

  const { updateEntities } = useContext(CommentsContext)
  const [Block, setBlock] = useState(data.isBlocking);
  const [TotalComment, setTotalComment] = useState(0);
  const [BlockDelete, setBlockDelete] = useState(false);
  const [placeBlocking, setPlaceBlocking] = useState(false);

  if (Array.isArray(months)) {
    const ranges = months?.map(value => {
      const range = Array
        .from(moment.range(value[0], value[1]).by("month"))
        ?.map(r => r.format("MMMM YYYY"))

      return range.join(", ")
    })

    formattedMonths = `| ${ranges.join(" | ")} |`
  }

  const { submission: { verificationTypes } } = implementer

  useEffect(() => {
    if (commentID) {
     
      commentID && updateEntities([{ entity: "activity", id: commentID }])
    }
  }, [commentID])

   useEffect(()=>{
      if(TotalComment > 0 && rol){
        setBlockDelete(true)
      } 
    },[TotalComment])


  const bloquear = () =>{
    setBlock(!Block)
  }

  const getNamePlace = (place) =>{

    if(isArray(place)){

      const hasBlockingPlace = place.some((placeId) => {
      const placeData = implementationPlace.find(({ id }) => id === placeId);
      return placeData?.isBlocking === true;
      });
    

    setPlaceBlocking(hasBlockingPlace);


      const namePlaces =  place.map((place)=>{
        const name = implementationPlace.find(({id})=> id === place) 
        
        return name?.place ?? place
      })
      return namePlaces.join(', ');
    }else{
      return place
    }
    
  }
  
  let bottonsblock = data.isBlocking && rol

  return (
    <Draggable
      index={index}
      isDragDisabled={readOnly}
      key={`${activityType}_${objectiveIndex}_${index}`}
      draggableId={`${activityType}_${objectiveIndex}_${index}`}>
      {draggableProvided => (
        <div ref={draggableProvided.innerRef} {...draggableProvided.draggableProps}>
          <Card key={`indicator_${key}`} style={{ paddingLeft: 0, marginBottom: "20px" }}>
            <Row style={{ width: "100%" }}>
              <Col span={1} style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                <MenuOutlined {...draggableProvided.dragHandleProps} />
              </Col>
              <Col span={21}>
                {placeBlocking && 
                  <>
                  <Typography.Text strong style={{color:"#dcad2b"}}>
                  La actividad tiene una ubicacion no disponible por favor actualizala
                  </Typography.Text>
                  <br />
                  </>
                }
                <Typography.Text strong>
                  Actividad {+orderIndex + 1}: {title || "Actividad sin titulo"}
                </Typography.Text>
                <br />
                <Typography.Text>{description || "N/A"}</Typography.Text>
                <br />
                <Typography.Text type="secondary">
                  {responsible || "N/A"}
                </Typography.Text>
                <br />
                <Typography.Text strong>Línea base: </Typography.Text>
                <Typography.Text>{baseline || "N/A"}</Typography.Text>
                &nbsp;
                <Typography.Text strong>Meta: </Typography.Text>
                <Typography.Text>{goal || "N/A"}</Typography.Text>
                &nbsp;
                <Typography.Text strong>Medio de verificación: </Typography.Text>
                <Typography.Text>
                  {meansOfVerification?.length ? (
                    meansOfVerification.map(method =>
                      getReadableValue(verificationTypes, method)
                    ).join(", ")
                  ) : "N/A"}
                </Typography.Text>
                <br />
                <Typography.Text strong>Lugar de implementación: </Typography.Text>
                <Typography.Text>{getNamePlace(place)}</Typography.Text>
                &nbsp;
                <Typography.Text strong>Mes de implementación: </Typography.Text>
                <Typography.Text>{formattedMonths || "N/A"}</Typography.Text>
              </Col>
              <Col
                span={2} style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "4px"
              }}>
                {(!readOnly && !review && !bottonsblock && !BlockDelete) &&
                  <DeleteButton
                    onClick={onDelete}
                    style={{ marginLeft: "8px" }} />
                }
                <EditButton onClick={onEdit} />
                {(!readOnly && !review && onDuplicate && !bottonsblock) &&
                  <Button
                    onClick={() => {
                      // treat the duplicated item as a new item without id
                      // eslint-disable-next-line no-unused-vars
                      const { id, metodologyDocuments, ...item } = data
                      onDuplicate({
                        ...item,
                        // omit the document ids
                        metodologyDocuments: (metodologyDocuments || []).map(doc => ({
                          name: doc.name,
                          url: doc.url
                        }))
                      })
                    }}
                    shape="circle"
                    size="middle">
                    <CopyOutlined />
                  </Button>
                }
                {admin && <Button
                  style={{ float: "right", marginLeft:"2px"}}
                  size="medium"
                  shape="circle"
                  icon={Block ? <LockOutlined style={{ color: '#e01717' }}/> : <UnlockOutlined style={{ color: '#43b61c' }}/>}
                  onClick={() => {

                    let newData={
                      ...data,
                      isBlocking:!Block
                    }
                    
                    BlockComponent(newData,"","Actividad",bloquear)

                  }} />}
                 <CommentButton  isSpecSheet={true} idSpecSheet={"activity"} entityId={commentID}  countComments={setTotalComment}/>
              </Col>
            </Row>
          </Card>
        </div>
      )}
    </Draggable>
  )
}
